import { render, staticRenderFns } from "./CompetitionsEdit.vue?vue&type=template&id=0048d299&"
import script from "./CompetitionsEdit.vue?vue&type=script&lang=js&"
export * from "./CompetitionsEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports